// Personal Agenda Recurring Events Dataset

export const defaultVisibleDate = new Date('2025-07-01T00:00:00');

export const initialEvents = [
  // Work events
  {
    id: 'work-daily-standup',
    start: '2025-07-02T09:00:00',
    end: '2025-07-02T09:30:00',
    title: 'Daily Standup',
    resource: 'work',
    rrule: 'FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR',
  },
  {
    id: 'work-retro',
    start: '2025-07-01T16:00:00',
    end: '2025-07-01T17:00:00',
    title: 'Team Retrospective',
    resource: 'work',
    rrule: 'FREQ=WEEKLY;INTERVAL=2;BYDAY=TU',
  },
  {
    id: 'work-backlog-grooming',
    start: '2025-07-09T14:00:00',
    end: '2025-07-09T15:00:00',
    title: 'Backlog Grooming',
    resource: 'work',
    rrule: 'FREQ=WEEKLY;INTERVAL=2;BYDAY=WE',
  },
  {
    id: 'work-1on1-john',
    start: '2025-07-09T10:00:00',
    end: '2025-07-09T11:00:00',
    title: '1-on-1 with John',
    resource: 'work',
    rrule: 'FREQ=WEEKLY;INTERVAL=3;BYDAY=WE',
  },
  {
    id: 'work-1on1-abigail',
    start: '2025-07-03T10:00:00',
    end: '2025-07-03T11:00:00',
    title: '1-on-1 with Abigail',
    resource: 'explore',
    rrule: 'FREQ=WEEKLY;INTERVAL=3;BYDAY=TH',
  },
  {
    id: 'work-1on1-hailey',
    start: '2025-07-07T10:00:00',
    end: '2025-07-07T11:00:00',
    title: '1-on-1 with Hailey',
    resource: 'data-grid',
    rrule: 'FREQ=WEEKLY;INTERVAL=3;BYDAY=MO',
  },
  {
    id: 'weekly-planning-explore',
    start: '2025-07-08T10:00:00',
    end: '2025-07-08T11:00:00',
    title: 'Weekly planning',
    resource: 'explore',
    rrule: 'FREQ=WEEKLY;INTERVAL=2;BYDAY=TU',
  },
  {
    id: 'weekly-planning-data-grid',
    start: '2025-07-04T10:00:00',
    end: '2025-07-04T11:00:00',
    title: 'Weekly planning',
    resource: 'data-grid',
    rrule: 'FREQ=WEEKLY;INTERVAL=2;BYDAY=FR',
  },
  // Non-recurring work events
  {
    id: 'client-call-1',
    start: '2025-07-03T16:00:00',
    end: '2025-07-03T17:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'client-call-2',
    start: '2025-07-07T15:00:00',
    end: '2025-07-07T15:45:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'client-call-3',
    start: '2025-07-10T15:00:00',
    end: '2025-07-10T15:30:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'client-call-4',
    start: '2025-07-18T11:00:00',
    end: '2025-07-18T11:45:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'client-call-5',
    start: '2025-07-24T11:00:00',
    end: '2025-07-24T11:45:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'design-review-1',
    start: '2025-07-08T15:00:00',
    end: '2025-07-08T17:00:00',
    title: 'Design review Scheduler',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'remote-1',
    start: '2025-07-02T09:00:00',
    end: '2025-07-02T12:00:00',
    title: 'Remote work',
    resource: 'work',
  },
  // Holiday events
  {
    id: 'holidays-1',
    start: '2025-06-25T00:00:00',
    end: '2025-06-30T00:00:00',
    title: 'Out of office',
    resource: 'holidays',
    allDay: true,
  },
  // Workout recurring events
  {
    id: 'workout-running',
    start: '2025-06-30T07:00:00',
    end: '2025-06-30T07:45:00',
    title: 'Running',
    resource: 'workout',
    rrule: 'FREQ=WEEKLY;BYDAY=MO,WE',
  },
  {
    id: 'workout-long-run',
    start: '2025-07-06T09:00:00',
    end: '2025-07-06T10:30:00',
    title: 'Long run',
    resource: 'workout',
    rrule: 'FREQ=WEEKLY;BYDAY=SU',
  },
  {
    id: 'workout-gym-class',
    start: '2025-07-01T18:00:00',
    end: '2025-07-01T19:00:00',
    title: 'Evening Gym Class',
    allDay: false,
    resource: 'workout',
    rrule: 'FREQ=WEEKLY;BYDAY=TU,TH',
  },
  // Birthday events
  {
    id: 'birthdays-alice',
    start: '2025-07-03T03:00:00',
    end: '2025-07-03T04:00:00',
    title: "Alice's Birthday",
    resource: 'birthdays',
    allDay: true,
    readOnly: true,
    rrule: 'FREQ=YEARLY',
  },
  {
    id: 'birthdays-bob',
    start: '2025-07-18T03:00:00',
    end: '2025-07-18T04:00:00',
    title: "Bob's Birthday",
    resource: 'birthdays',
    allDay: true,
    readOnly: true,
    rrule: 'FREQ=YEARLY',
  },
  {
    id: 'birthdays-richard',
    start: '2025-07-25T03:00:00',
    end: '2025-07-25T04:00:00',
    title: "Richard's Birthday",
    resource: 'birthdays',
    allDay: true,
    readOnly: true,
    rrule: 'FREQ=YEARLY',
  },
  // Personal events
  {
    id: 'dinner-with-friends-1',
    start: '2025-07-04T19:30:00',
    end: '2025-07-04T22:00:00',
    title: 'Dinner with Friends',
    resource: 'personal',
    readOnly: true,
  },
  {
    id: 'dinner-with-friends-2',
    start: '2025-07-15T19:30:00',
    end: '2025-07-15T21:00:00',
    title: 'Dinner with Friends',
    resource: 'personal',
    readOnly: true,
  },
  {
    id: 'dinner-with-friends-3',
    start: '2025-07-28T19:30:00',
    end: '2025-07-28T21:30:00',
    title: 'Dinner with Friends',
    resource: 'personal',
    readOnly: true,
  },
  {
    id: 'shopping-1',
    start: '2025-07-19T14:00:00',
    end: '2025-07-19T16:30:00',
    title: 'Shopping',
    resource: 'personal',
  },
  {
    id: 'shopping-2',
    start: '2025-07-26T13:00:00',
    end: '2025-07-26T16:00:00',
    title: 'Shopping',
    resource: 'personal',
  },
  {
    id: 'community-workshop',
    start: '2025-07-26T10:00:00',
    end: '2025-07-26T12:00:00',
    title: 'Community Workshop',
    resource: 'personal',
    rrule: 'FREQ=MONTHLY;BYDAY=4SA',
  },
  // Medical events
  {
    id: 'medical-1',
    start: '2025-07-02T17:30:00',
    end: '2025-07-02T18:00:00',
    title: 'Dental Checkup',
    resource: 'medical',
  },
  {
    id: 'medical-2',
    start: '2025-07-17T15:00:00',
    end: '2025-07-17T16:30:00',
    title: 'Physical Therapy',
    resource: 'medical',
  },
  {
    id: 'medical-3',
    start: '2025-07-19T09:00:00',
    end: '2025-07-19T09:15:00',
    title: 'Prescription Pickup',
    resource: 'medical',
  },
];

export const resources = [
  {
    title: 'Work',
    id: 'work',
    eventColor: 'purple',
    children: [
      {
        title: 'eXplore Team',
        id: 'explore',
        eventColor: 'pink',
        children: [
          { title: 'Design meetings', id: 'design-meetings', eventColor: 'grey' },
        ],
      },
      { title: 'Data Grid Team', id: 'data-grid', eventColor: 'blue' },
    ],
  },
  { title: 'Holidays', id: 'holidays', eventColor: 'red' },
  { title: 'Workout', id: 'workout', eventColor: 'teal' },
  { title: 'Birthdays', id: 'birthdays', eventColor: 'lime' },
  { title: 'Personal', id: 'personal', eventColor: 'orange' },
  { title: 'Medical', id: 'medical', eventColor: 'indigo' },
];
